import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { GsmAuthService } from '@app/shared/services/data/gsm-auth.service';
import { RouterService } from '@app/shared/services/router.service';
import { LowLevelApi } from '@app/shared/services/state/low-level-api.service';
import { Observable } from 'rxjs';

/**
 * Checks if the user is authenticated and therefore authorized to activate the given route.
 */
@Injectable({
  providedIn: 'root'
})
export class GsmAuthGuard implements CanActivate {
  private llapi = inject(LowLevelApi);
  routerService = inject(RouterService);
  private gsmAuthService = inject(GsmAuthService);


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.llapi.patchValue('layout.spinner', false);
    return this.gsmAuthService.authenticate();
  }
}

